import { Container } from 'react-bootstrap';
import StandardsList from '../components/StandardsList';

const Standards = () => {
  return (
    <Container className="mt-4">
      <h2>Standards</h2>
      <StandardsList />
    </Container>
  );
};

export default Standards;
